(function () {
  'use strict';
  var buttons = Array.from(document.querySelectorAll('[data-lk-tryon-button]'));
  var script = document.querySelector('script[data-mk-project]');
  if (!buttons.length || !script || window.__lkPdpTryon) return;
  window.__lkPdpTryon = true;
  var projectId = script.getAttribute('data-mk-project');
  var status = document.querySelector('[data-lk-tryon-status]');
  var cache = new Map();
  var revision = 0, identifier = null, busy = false, state = null;
  var attempts = 0, timer = null, initialized = false;

  function ready() {
    return window.mk && typeof window.mk.open === 'function' && typeof window.mk.getAvailability === 'function';
  }
  function show(visible) {
    buttons.forEach(function (button) { button.hidden = !visible; });
    document.body.classList.toggle('lk-tryon-native-ready', visible || busy);
  }
  function message(text) {
    if (!status) return;
    status.textContent = text;
    status.hidden = !text;
  }
  function candidates() {
    var context = window.lkPdpContext || {};
    var input = document.getElementById('pdp-variant-id');
    var selected = state ? !state.pending && state.variant && state.variant.id : input && input.value;
    var variant = (context.variants || []).find(function (item) { return selected && String(item.id) === String(selected); });
    return Array.from(new Set([variant && variant.id, variant && variant.sku, context.productId]
      .filter(function (value) { return value != null && value !== false && String(value).trim() !== ''; })
      .map(function (value) { return String(value).trim(); })));
  }
  function availability(id) {
    if (!cache.has(id)) {
      var request = Promise.resolve().then(function () { return window.mk.getAvailability(projectId, id); })
        .then(function (result) {
          if (!result || result.available !== true) cache.delete(id);
          return !!result && result.available === true;
        }, function (error) { cache.delete(id); throw error; });
      cache.set(id, request);
    }
    return cache.get(id);
  }
  async function refresh() {
    var current = ++revision;
    identifier = null;
    show(false);
    message('');
    if (!initialized || !ready()) return;
    var ids = candidates();
    try {
      for (var i = 0; i < ids.length; i++) {
        var available = await availability(ids[i]);
        if (current !== revision) return;
        if (available) { identifier = ids[i]; show(true); return; }
      }
    } catch (_) { /* Keep the original SDK launcher on transient failures. */ }
  }
  async function open(event) {
    event.preventDefault();
    if (busy || !identifier || !ready()) return;
    busy = true;
    message('');
    buttons.forEach(function (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    var notice = setTimeout(function () { message('O provador está demorando para abrir. Aguarde um instante.'); }, 10000);
    try { await window.mk.open({ projectId: projectId, identifier: identifier }); message(''); }
    catch (_) { message('Não foi possível abrir o provador. Tente novamente.'); }
    finally {
      clearTimeout(notice);
      busy = false;
      document.body.classList.toggle('lk-tryon-native-ready', !!identifier);
      buttons.forEach(function (button) { button.disabled = false; button.removeAttribute('aria-busy'); });
    }
  }
  function boot() {
    if (initialized) return;
    if (timer !== null) { clearTimeout(timer); timer = null; }
    // Older SDK fallbacks use an unmarked closed-shadow host. Keep their launcher.
    if (ready() && document.querySelector('.mk-tryon-button, .lk-tryon-docked')) {
      initialized = true; refresh(); return;
    }
    if (attempts++ < 120) timer = setTimeout(boot, 500);
  }
  buttons.forEach(function (button) { button.addEventListener('click', open); });
  document.addEventListener('lk:pdp-state', function (event) { state = event.detail || null; refresh(); });
  script.addEventListener('load', boot);
  window.addEventListener('load', boot);
  boot();
})();
